<template>
    <Card title="Configuración de Deportistas" padding="4">
        <div class="tw:space-y-6">

            <div>
                <ToggleSwitch
                    id="activar_compra_por_invitacion_bases"
                    v-model="managerLocal.activar_compra_por_invitacion_bases"
                    aria-label="Activar inscripción cantera por invitación con código"
                >
                    Activar la inscripción cantera por invitación con código
                </ToggleSwitch>
            </div>

            <div>
                <ToggleSwitch
                    id="documentacion_obligatoria_bases"
                    v-model="managerLocal.documentacion_obligatoria_bases"
                    aria-label="Documentación obligatoria"
                >
                    La documentación del deportista será obligatoria en el proceso de compra
                </ToggleSwitch>
            </div>

            <div>
                <ToggleSwitch
                    id="indumentaria_plazos"
                    v-model="managerLocal.indumentaria_plazos"
                    aria-label="La indumentaria se paga a plazos"
                >
                    La indumentaria se paga a plazos
                </ToggleSwitch>
            </div>

            <div>
                <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-2">
                    Texto de información sobre las bases:
                </label>
                <QuillEditor v-model="managerLocal.informacion_base" />
            </div>

            <div>
                <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-2">
                    Texto para las condiciones de la compra en cantera mediante plazos:
                </label>
                <QuillEditor v-model="managerLocal.condiciones_bases_plazos" />
            </div>

            <div>
                <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-2">
                    Imagen cantera:
                </label>
                <p class="tw:text-xs tw:text-gray-500 tw:mb-3">
                    MEDIDAS: 960X276 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB
                    <br/>
                    * No introduzcas texto en la imagen.
                </p>
                <div v-if="manager.imagen_info_bases_url" class="tw:text-center">
                    <img
                        :src="manager.imagen_info_bases_url"
                        class="tw:max-h-48 tw:mx-auto tw:mb-3 tw:rounded"
                    />
                    <Button @click="imagenBorrada">Borrar imagen</Button>
                </div>
                <Dropzone
                    v-else-if="uploadUrl"
                    :url="uploadUrl"
                    :height="276"
                    :width="960"
                    @success="imagenSubida"
                />
            </div>

            <div class="tw:flex tw:justify-end">
                <Button :loading="saving" @click="onGuardar">
                    Guardar
                </Button>
            </div>

        </div>
    </Card>
</template>

<script setup>
    import Card from '@/modules/admin/ui/Card.vue';
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import QuillEditor from '@/modules/ui/QuillEditor.vue';
    import Dropzone from '@/components/common/Dropzone';
    import { useConfiguracionDeportistas } from '@/composables/admin/configuracion/deportistas/useConfiguracionDeportistas';

    const props = defineProps({
        manager: { type: Object, required: true }
    });

    const emit = defineEmits(['guardar']);

    const { managerLocal, saving, uploadUrl, imagenBorrada, imagenSubida, guardar } =
        useConfiguracionDeportistas(props.manager);

    async function onGuardar() {
        const ok = await guardar();
        if (ok) emit('guardar', managerLocal);
    }
</script>
